<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: "wiki"
  }
</script>

<style scoped>
</style>
